/**
 * Legacy redirect: /user/admin → /admin/team.
 * @file src/web/features/user/pages/admin/index.tsx
 *
 * The old userapp "admin" user-management screen has been superseded by the
 * professional Team page. This file is kept ONLY so the discovered route `/user/admin`
 * still resolves — it now bounces to /admin/team so old bookmarks, the
 * dashboard CTA, and the role-gate entry keep landing somewhere useful instead
 * of 404-ing. `replace` so the dead URL doesn't linger in history.
 */

import { Navigate } from 'react-router-dom';

export default function LegacyUserAdminRedirect() {
  return <Navigate to="/admin/team" replace />;
}
